import Phaser from 'phaser';
import dimensions from '../dimensions';

export default class extends Phaser.State {
    init() {}

    preload() {
        this.loader = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loader');
        this.loader.anchor.set(0.5);

        let scaleX = dimensions.fullWidth / 1333;
        let scaleY = dimensions.fullHeight / 1000;

        this.gameScale = scaleX < scaleY ? scaleX : scaleY;

        this.loader.scale.set(this.gameScale);
        this.game.add.tween(this.loader).to({ angle: 360 }, 1500, "Linear", true, 0, -1);

        // Images
        this.load.image('bg_mission_1_1', SpecialDefinitions.path_backgrounds + 'Mission_1_1_Background.jpg');
        this.load.image('bg_mission_1_2', SpecialDefinitions.path_backgrounds + 'Mission_1_2_Background.jpg');
        this.load.image('bg_mission_1_3', SpecialDefinitions.path_backgrounds + 'Mission_1_3_Background.jpg');
        this.load.image('bg_mission_2_1', SpecialDefinitions.path_backgrounds + 'Mission_2_1_Background.jpg');
        this.load.image('bg_mission_2_2', SpecialDefinitions.path_backgrounds + 'Mission_2_2_Background.jpg');
        this.load.image('bg_mission_2_3', SpecialDefinitions.path_backgrounds + 'Mission_2_3_Background.jpg');
        this.load.image('bg_mission_3_1', SpecialDefinitions.path_backgrounds + 'Mission_3_1_Background.jpg');
        this.load.image('bg_mission_3_2', SpecialDefinitions.path_backgrounds + 'Mission_3_2_Background.jpg');
        this.load.image('bg_mission_3_3', SpecialDefinitions.path_backgrounds + 'Mission_3_3_Background.jpg');
        this.load.image('bg_mission_4_1', SpecialDefinitions.path_backgrounds + 'Mission_4_1_Background.jpg');
        this.load.image('bg_mission_5_1', SpecialDefinitions.path_backgrounds + 'Mission_5_1_Background.jpg');
        this.load.image('bg_mission_6_1', SpecialDefinitions.path_backgrounds + 'Mission_6_1_Background.jpg');
        this.load.image('bg_mission_7_1', SpecialDefinitions.path_backgrounds + 'Mission_7_1_Background.jpg');
        this.load.image('bg_mission_7_2', SpecialDefinitions.path_backgrounds + 'Mission_7_2_Background.jpg');
        this.load.image('main_menu', SpecialDefinitions.path_backgrounds + 'MainMenu_Background.jpg');

        // Fonts
        this.load.bitmapFont('font-letters-blue', SpecialDefinitions.path_fonts + 'font-letters-blue.png', SpecialDefinitions.path_fonts + 'font-letters-blue.fnt');
        this.load.bitmapFont('font-letters-yellow', SpecialDefinitions.path_fonts + 'font-letters-yellow.png', SpecialDefinitions.path_fonts + 'font-letters-yellow.fnt');
        this.load.bitmapFont('font-ui', SpecialDefinitions.path_fonts + 'font-ui.png', SpecialDefinitions.path_fonts + 'font-ui.fnt');
        this.load.bitmapFont('font-text', SpecialDefinitions.path_fonts + 'font-text.png', SpecialDefinitions.path_fonts + 'font-text.fnt');
        this.load.bitmapFont('font-title', SpecialDefinitions.path_fonts + 'font-title.png', SpecialDefinitions.path_fonts + 'font-title.fnt');
        this.load.bitmapFont('font-countdown', SpecialDefinitions.path_fonts + 'font-countdown.png', SpecialDefinitions.path_fonts + 'font-countdown.fnt');
        this.load.bitmapFont('font-game-title', SpecialDefinitions.path_fonts + 'font-game-title.png', SpecialDefinitions.path_fonts + 'font-game-title.fnt');

        // Sounds
        this.load.audio("menuMusic", SpecialDefinitions.path_sounds + "typing_openingPage.mp3");
        this.load.audio("comms", SpecialDefinitions.path_sounds + "typing_playforcomms.mp3");
        this.load.audio("missionMusic", SpecialDefinitions.path_sounds + "typing_playforRealMissions.mp3");
        this.load.audio("simMusic", SpecialDefinitions.path_sounds + "typing_playforSimulator.mp3");
        this.load.audio("countdown", SpecialDefinitions.path_sounds + "typing_playforcountdown.mp3");
        this.load.audio("explode", SpecialDefinitions.path_sounds + "typing_playwhenlettersexplode.mp3");
        this.load.audio("button_click", SpecialDefinitions.path_sounds + "button_click.mp3");

        // Spritesheet
        this.load.atlasJSONHash('sheet', SpecialDefinitions.path_sheets + 'sheet.png', SpecialDefinitions.path_sheets + 'sheet.json');

        this.gameResized();
        this.scale.setResizeCallback(this.gameResized, this);
    }

    gameResized() {
        let ratio = 1;

        if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) ratio = window.screen.systemXDPI / window.screen.logicalXDPI;else if (window.devicePixelRatio !== undefined) ratio = window.devicePixelRatio;

        dimensions.fullWidth = window.innerWidth * ratio;
        dimensions.fullHeight = window.innerHeight * ratio;

        if (this.game.width === dimensions.fullWidth && this.game.height === dimensions.fullHeight) return;

        this.game.scale.setGameSize(dimensions.fullWidth, dimensions.fullHeight);

        this.loader.x = this.game.world.centerX;
        this.loader.y = this.game.world.centerY;
    }

    create() {
        this.loader.destroy();
        this.state.start('Menu');
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/states/Preloader.js
// module id = 150
// module chunks = 0